import { IConfirmAbsenceWarningDTO } from 'shared/domain/dtos';
import { IAbsenceWarningRepository } from 'shared/domain/repositories';

export default class ConfirmAbsenceWarningUseCase {
  constructor(private absenceWarningRepository: IAbsenceWarningRepository) {}

  public async execute({
    customerId,
    moment,
    channel,
    flow,
    scheduleId,
  }: IConfirmAbsenceWarningDTO) {
    return this.absenceWarningRepository.confirm({
      customerId,
      moment,
      channel,
      flow,
      scheduleId,
    });
  }
}
